<template>
    <a :href="href" :class="(hollow ? 'btn-hollow' : 'btn-general') + ' align-middle'">{{ caption }}</a>
</template>

<script>

export default{
    name: 'ButtonComponent',
    props: {
        'caption':{
            type: String
        },
        'href':{
            type: String
        },
        'hollow':{
            type: Boolean,
            default: false
        }
    }
}
</script>